import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Text } from '../../components/Text';
import Hint from '../../components/ModuleDrawer/Hint';
import { LoadingBar } from '../../components/util/LoadingBar';
import { DynamicWrapper } from '../../components/util/DynamicWrapper';
import { SliderControl } from '../../components/controls/NewSliderControl';
import { Checkbox } from 'rmwc/Checkbox';
import { backOnboarding, continueOnboarding, pathAware } from '../../actions/onboardingActions';
import { currencyFormatter } from '../../components/Money';

class EquityAllocation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      equityAllocation: props.qna_hash.equityAllocation ? props.qna_hash.equityAllocation.answer : 50,
      equityAllocationUnknown: props.qna_hash.equityAllocationUnknown
        ? props.qna_hash.equityAllocationUnknown.answer
        : false,
    };
  }

  componentDidMount() {
    this.props.pathAware('equityAllocation');
  }

  componentWillReceiveProps(props) {
    if (props.qna_hash.equityAllocation) {
      this.setState({
        equityAllocation: props.qna_hash.equityAllocation.answer,
        equityAllocationUnknown: props.qna_hash.equityAllocationUnknown.answer,
      });
    }
  }

  _onContinue = () => {
    const { onContinue, qna_hash, qna_stack } = this.props;

    this.props
      .continueOnboarding(qna_stack, qna_hash, {
        equityAllocation: {
          question: 'What level of risk are you comfortable with?',
          answer: this.state.equityAllocationUnknown ? undefined : this.state.equityAllocation,
        },
        equityAllocationUnknown: {
          question: 'Do you not know or are you not sure about your risk level?',
          answer: this.state.equityAllocationUnknown,
        },
      })
      .then(onContinue);
  };

  _onBack = () => {
    this.props.backOnboarding(this.props.qna_stack).then(this.props.onBack);
  };

  onChange = evt => {
    this.setState({ equityAllocation: evt.detail.value });
  };

  onChangeEquityAllocationUnknown = evt => {
    this.setState({ equityAllocationUnknown: evt.target.checked });
  };

  render() {
    const { qna_hash, wrapper } = this.props;
    const { equityAllocation, equityAllocationUnknown } = this.state;

    return (
      <DynamicWrapper
        style={{ width: '100%' }}
        wrapper={wrapper}
        onContinue={this._onContinue}
        onBack={this._onBack}
        canContinue
        helperText={<Hint>Don't worry about getting it perfect! You'll be able to update this information later.</Hint>}
      >
        <div style={{ width: '90%', display: 'flex', justifyContent: 'center' }}>
          <Text use="headline6">How much of your portfolio is invested in equities?</Text>
        </div>
        <div style={{ width: '100%' }}>
          <Text use="body1" className="ml-4 mr-4">
            Equities are also known as "stocks." If you own mutual funds or ETFs, try to estimate the portion of stocks
            that those fund own.
          </Text>
        </div>

        {equityAllocationUnknown || (
          <div className="mt-3" style={{ width: '80%', display: 'flex', justifyContent: 'space-around' }}>
            <Text className="m-0" use="body1">
              0%
            </Text>
            <SliderControl
              id="equityAllocation"
              className="ml-3 mr-3"
              style={{ width: '70%' }}
              spec={{
                field_type: 'range',
                min: 0,
                max: 100,
                step_size: 0,
                _default: 100,
              }}
              onChange={this.onChange}
              onInput={this.onChange}
              value={equityAllocation}
              discrete
              persistentPin
            />
            <Text className="m-0" use="body1">
              100%
            </Text>
          </div>
        )}
        <Checkbox
          id="equityAllocationUnknown"
          onChange={this.onChangeEquityAllocationUnknown}
          checked={equityAllocationUnknown}
          label="I don't know or I'm not sure"
        />
      </DynamicWrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    qna_hash: state.onboarding.qna_hash,
    qna_stack: state.onboarding.qna_stack,
  };
}

export default connect(mapStateToProps, { backOnboarding, continueOnboarding, pathAware })(EquityAllocation);
